export default {"src":"/_next/static/media/building.6922a3d7.svg","height":30,"width":36};